module.exports = __webpack_public_path__ + "static/media/java2.e27eba9a.png";